export default __webpack_public_path__ + "static/media/popup_9D.ee31ecf9.png";